import React from "react";

export const poesiasInfantilesPomboPublishedAt = (
  <span className="white">
    <i>Hojas de cultura popular colombiana</i>, No. 25. Ministerio de Educación Nacional (1953)
  </span>
);
